import request from "./api";
//获取科目树
export const getMaterial = (params, opts) => request("/api-resource/cjdd-resources/resourses/get/material/catalog", params, opts);
//获取课程目录
export const getCourseCatalog = (id, params, opts) => request("/api-course/catalog/catalog/"+id, params, opts);//获取课程目录
export const newGetCourseCatalog = (id, type, params, opts) => request(`/api-course/catalog/catalogByType/${id}/${type}`, params, opts);
//获取课程目录 包含已删除的
export const allGetCourseCatalog = (params, opts) => request(`/api-course/course/catalog/del/findCourseCatalog`, params, { ...opts, method: "post" });
/**
 *  获取课程目录  2021.7.6 后端接口 马晋霞 。返回过滤数据，带课程类型。
 *  resourceType  1图片，2文档, 3音频，4视频，6图文
 *  type 1:素材,2:作业,3:习题,5:测验,6:图文
 **/
export const getCourseAllCatalog = (id, params, opts) => request("/api-course/catalog/allCatalog/"+id, params, opts);
//添加目录
export const addCatalog = (params, opts) => request("/api-course/catalog/catalog", params, { ...opts, method: "post" });
//删除目录
export const deleteCatalog = (id, params, opts) => request("/api-course/catalog/catalog/"+id, params, { ...opts, method: "delete" });
// 批量删除目录
export const batchDeleteCatalog = (params) => request("/api-course/catalog/batchDelete", params, { method: "post" });
// 批量还原目录
export const batchRestoreCatalog = (params) => request("/api-course/course/catalog/del/restoreCatalog", params, { method: "post" });
//编辑目录
export const editCatalogSave = (params, opts) => request("/api-course/catalog/updateCatalog", params, { ...opts, method: "put" });
//点击目录
export const handleNodeClick = (courseId, id, params, opts) => request("/api-course/catalog/catalog/"+courseId+'/'+id, params, opts);
// 回收站点击获取资源
export const handleRecycleNodeClick = (params) => request("/api-course/course/catalog/del/queryResource", params, { method: "post" });
//移动目录
export const handleDrop = (params, opts) => request("/api-course/catalog/catalog", params, { ...opts, method: "put" });
//移动素材
export const moveMaterial = (params, opts) => request("/api-course/catalog/move", params, { ...opts, method: "put" });
// 保存图文内容
export const postAddImageText = (params) => request("/api-resource/cjdd-resources/resourses/save/material/attachment", params, { method: "post" });
// //查询科目下试题
// export const queryQuestion = (params, opts) => request("/api-resource/taskEventres/queryUnionQst", params, { ...opts, method: "post" });
//获取课程列表
export const queryCourse = (params, opts) => request("/api-course/course/query", params, { ...opts, method: "post" });
//获取课程列表 -- 书证融通
export const queryCourseCirculate = (params, opts) => request("/api-course/course/circulate/query", params, { ...opts, method: "post" });
//根据课程id获取课程信息
export const getCourseInfo = (id, params, opts) => request("/api-course/course/"+id, params, opts);
// 根据班级id查询信息
export const getClassInfo = (id, params, opts) => request("/api-course/class/query/"+id, params, opts);
//根据科目id获取题型
export const getQuestionType = (id, params, opts) => request("/api-resource/questionType/select?subjectId="+id, params, opts);
//获取试题用途&标签
export const getQuestionPurpose = (params, opts) => request("/api-resource/question/findLabel", params, opts);
//根据科目id获取公司
export const queryCompany = (params, opts) => request("/api-resource/company/query/by/lable", params, { ...opts, method: "post" });
export const getCompany = (params, opts) => request("/api-course/realTask/findCompany", params, { ...opts, method: "post" });
// 新增自定义标签
export const InsertLable = (params, opts) => request('/api-resource/question/insertLable', params, { ...opts, method: 'post' });
// 删除自定义标签
export const DeleteLable = (params, opts) => request('/api-resource/question/deleteLable', params, { ...opts, method: 'post' });
// 编辑课程内目录设置
export const setCatalog = (params, opts) => request('/api-course/catalog/lockset', params, { ...opts, method: 'post' });
// 书证融通课程内目录锁定设置
export const setCourseCatalog = (params, opts) => request('/api-course/catalog/courseLockset', params, { ...opts, method: 'post' });
// 目录自动编号
export const editCatalogSort = (params) => request("/api-course/catalogSort/editCatalogSort", params, { method: "post" });
//批量添加目录
export const addCatalogBatch = (params, opts) => request("/api-course/catalog/batchSave", params, { ...opts, method: "post" });
// 获取预览classId
export const queryPreviewClass = (params, opts) => request("/api-course/class/queryPreviewClass", params, { ...opts, method: "post" });




//获取试题列表
export const queryQuestionList = (params, opts) => request("/api-resource/question/select", params, { ...opts, method: "post" });
//查询当前用户可用的科目
export const getSubjectList = (params, opts) => request("/api-resource/cjdd-resources/currentUser/subjects", params, opts);
export const getSubjectData = (params, opts) => request("/api-resource/cjdd-resources/currentUserPermission/subjects", params, opts);
//编辑课程基础信息
export const updateCourse = (params, opts) => request("/api-course/course/update", params, { ...opts, method: "put" });
//添加课程
export const addCourse = (params, opts) => request("/api-course/course/addV2", params, { ...opts, method: "post" });
//复制课程
export const copyCourse = (params, opts) => request("/api-course/course/copy/"+params.id, params, opts);
//删除课程
export const deleteCourse = (id, params, opts) => request("/api-course/course/delete/"+id, params, { ...opts, method: "delete" });
//添加实操题
export const submitMaterialBtn = (params, opts) => request("/api-course/catalog/add/material", params, { ...opts, method: "post" });
//  新课程页面， 添加内容，只能添加一项
export const postAddMaterialOne = (params, opts) => request("/api-course/catalog/add/material/one", params, { ...opts, method: "post" });
//删除目录关联资源
export const deleteSource = (params, opts) => request("/api-course/catalog/delete/"+params.catalogInfoId+"/"+params.id+"/"+params.type, params, { ...opts, method: "delete" });
//批量删除资源
export const batchDeleteSource = (params, opts) => request("/api-course/catalog/batch/delete", params, { ...opts, method: "post" });

// 跨目录移动资源
export const moveResourceKuaCatalog = (params) => request("/api-course/catalog/moveResourceKuaCatalog", params, { method: "put" });

//查询试卷是否有学习记录
export const getExamRecord = (courseId, paperId, params, opts) => request("/api-study/check/exam/record/"+courseId+'/'+paperId, params, opts);
//更改资源状态（设为任务、允许下载）
export const changeCheck = (params, opts) => request("/api-course/catalog/update", params, { ...opts, method: "put" });
//批量更改资源状态
export const batchChangeCheck = (params, opts) => request("/api-course/catalog/batch/update", params, { ...opts, method: "post" });
// 添加试题
export const createQuestiontData = (params, opts) => request('/api-resource/question/insert', params, { ...opts, method: 'post' });
// 修改试题
export const UpdateTestData = (params, opts) =>  request('/api-resource/question/update', params, { ...opts, method: 'post' });
// 根据科目id查询知识点
export const FindMaterials = (params, opts) => request(`/api-resource/cjdd-resources/resourses/get/material/catalog/${params}`, opts);
// 根据科目id查询任务流
export const getTaskFlow = (params, opts) => request(`/api-resource/taskFlow/find/${params}`, opts);
// 获取真实任务列表
export const getTaskList = (params, opts) => request('/api-course/realTask/find', params, { ...opts, method: 'post' });
// 添加任务到列表
export const addTaskList = (params, opts) => request('/api-course/catalog/add/realTask', params, { ...opts, method: 'post' });
// 推送任务
export const publishTask = (params, opts) => request('/api-course/realTask/save', params, { ...opts, method: 'post' });
// 撤回任务
export const offlineTask = (params, opts) => request('/api-course/realTask/del/'+params, params, { ...opts, method: 'delete' });
//根据试题id查询附件列表
export const getAttachmentList = (params, opts) => request(`/api-resource/question/getAttachment`, params, opts);
//根据试题id查询事项
export const getQuestionEventById = (id) => request(`/api-resource/questionAnswer/findQuestionAnswerByQuestionId/${id}`);

//============================学习中心=====================
// 是否允许查看答案
export const isAnswers = (params, opts) => request('/api-course/courseClassParam/save', params, { ...opts, method: 'post' });
// 查询允许查看答案
export const isAnswerShow = (params, opts) => request('/api-course/courseClassParam/queryAnswerSet', params, { ...opts, method: 'post' });
//查询资源进度
export const qryResProgress = (params, opts) => request('/api-study/study/qryResProgress', params, { ...opts, method: 'post' });
// 根据目录查询关联资源信息接口
export const queryTask = (params, opts) => request('/api-course/catalog/query/task', params, { ...opts, method: 'post' });
// 根据目录查询关联资源信息接口--预览
export const queryTaskPreview = (params, opts) => request('/api-course/catalog/query/task/onPreView', params, { ...opts, method: 'post' });
// 根据目录查询关联资源信息接口
export const putCatalogResourceSort = (params, opts) => request('/api-course/catalog/sort', params, { ...opts, method: 'put' });
// 查询试题数据
export const QueryTestData = (params, opts) => request('/api-resource/question/select', params, { ...opts, method: 'post' });
//根据资源ID 获取动态参数列表
export const getparams = (params, opts) => request("/api-resource/dynmaicParam/get/dynmaic/param/list/"+params.resourceId+"/"+params.id+"/0", {}, opts);
//判断跳转评估，三天下。
export const jumpstx = (courseId, classId, params, opts) => request("/api-course/team/"+courseId+"/"+classId, params, opts);
//插入目录学习位置
export const insertDirectory = (params, opts) => request('/api-study/study/addToResRecord', params, { ...opts, method: 'post' });
// 做题记录---交卷
export const stySaveRecord = (params, opts) => request('/api-study/doQuestionRecord/saveRecord', params, {  ...opts, method: 'post'});

//查询目录学习位置
export const selectDirectory = (params, opts) => request('/api-study/study/qryResDetail', params, { ...opts, method: 'post' });
//统计学习次数
export const statisticsStudyNum = (params, opts) => request('/api-study/study/updateOrInsertRecord', params, { ...opts, method: 'post' });
//统计进度
export const statisticsProgress = (params, opts) => request('/api-study/study/initCourseRecord', params, { ...opts, method: 'post' });
//根据课程查询id查询目录接口
export const queryCourseCatalog = (courseId, classId, params, opts) => request("/api-course/catalog/course/"+courseId+"/"+classId, params, opts);
//获取学生学习进度
export const getStudentProgress = (params, opts) => request('/api-study/study/getUserProgress', params, { ...opts, method: 'post' });
//判断，考试作答，继续作答
export const getStartTest = (params, opts) => request('/api-study/student/test/paper/status', params, { ...opts, method: 'post' });
//视频播放结束
export const endVideo = (params, opts) => request('/api-action/apilog/save', params, { ...opts, method: 'post' });
//获取答案
export const getAnswer = (id, params, opts) => request("/api-resource/taskEventres/queryDetailByQuestionId/"+id, params, opts);
//获取答案
export const getQuestionDynmaicParam = (id, params) => request("/api-resource/dynmaicParam/get/allDynmaic/param/"+id, params);

// 把多个代码块形成一个文件s
export const postRunCoders = (params) =>
  request('/api-resource/code/data/save', params,{ method: 'post' });// 把多个代码块形成一个文件s
// 查询之前生成的文件
export const getCodersLog = ({targetId,targetType }) =>
  request('/api-resource/code/data/getByTargetId?targetId=' +targetId+ '&targetType='+ targetType, {});

// IT 评分core
export const postScore = (params) =>
  request('/python-compile/score', params,{ method: 'post' });
// 代码块评分
export const scoringCodeEntry = (params) =>
  request('/api-studylog-mq/ScoreController/scoringCodeEntry', params,{ method: 'post' });


// 获取IT评分结果（除代码块外）
export const getITScoringResults = params =>
  request('/api-score/scQuestionScoreItController/selectQuestionScoreIt', params, {
    method: 'post'
  });


//通过事项ID获取事项详情
export const getTemplateDetail = (ids, params, opts) => request("/api-resource/repeat/eventTemplate?ids="+ids, params, opts);
//通过事项ID获取事项中的动态参数配置
export const getDynmaicParam = ( o, params, opts) => request("/api-resource/dynmaicParam/get/dynmaic/param/list/"+o.myId+'/'+o.id+'/'+o.index,params,  opts);
// 根据资源ID 获取动态参数列表
export const examgetParams = (questionId, params, opts) => request('/api-resource/dynmaicParam/get/dynmaic/param/'+questionId, params, { ...opts });
//提交作答结果
export const submitAnswer  = (params, opts) => request("/api-score/study/study-end-test", params, opts);
export const submitAnswerstu = (params, opts) => request("/api-score/complex-train-start-score", params, { ...opts, method: "post", contentType: "application/x-www-form-urlencoded", });
//获取岗位
export const getMyStation = (courseId, classId, params, opts) => request("/api-course/team/find/myStation/"+courseId+"/"+classId, params, opts);
//获取笔记
export const stuNoteByCatalog = (params, opts) => request('/api-study/stuNoteByCatalog', params, { ...opts, method: 'post' });
//新增笔记
export const addNote = (params, opts) => request('/api-study/stuNote', params, { ...opts, method: 'post' });
//编辑笔记
export const editNote = (params, opts) => request('/api-study/stuNote', params, { ...opts, method: 'put' });
//删除笔记
export const deleteNote = (id) => request("/api-study/stuNote?id="+ id, {}, { method: "delete" });
//学习中心获取我的任务
export const getMmTask = (courseId, catalogId, classId, params, opts) => request('/api-course/catalog/find/myTask/'+courseId+'/'+catalogId+'/'+classId, params, { ...opts, method: 'post' });
//查询实操题是否属于我岗位
export const queryMyStationQes = (params, opts) => request('/api-resource/question/myQuestion', params, { ...opts, method: 'post' });


//重置前查询
export const queryResetExercise = (params, opts) => request('/api-course/resetExercise/queryResetExercise', params, { ...opts, method: 'post' });
//重置
export const resetExercise = (params, opts) => request('/api-course/resetExercise/resetExercise', params, { ...opts, method: 'post' });




//===================================
// 根据试卷id查询试卷详情
export const SelectById = (params, opts) =>
    // request('/api-resource/testPaper/selectById', params, opts);   // params {id: ''}
    request('/api-resource/testPaper/selectByIdNoPermission', params, opts);   // params {id: ''}

// 保存试卷
export const AddTestPaper = (params, opts) =>
    request('/api-resource/testPaper/addTestPaper', params, {
        ...opts,
        method: 'post'
    });



// 根据科目查询题型
export const FindTypeBySubject = (params, opts) =>
    request('/api-resource/questionType/select', params, opts);   // params {id: ''}
// 根据科目查询标签
export const FindLabel = (params, opts) =>
    request('/api-resource/question/findLabel', params, opts);   // params {id: ''}


//添加作答情况
export const SaveRecord = (params, opts) =>
    request('/api-image-hub/courseQuestionRecord/saveRecord', params, {
        ...opts,
        method: 'post'
    });
// 查询作答情况
export const QueryAnswer = (params, opts) =>
    request('/api-image-hub/courseQuestionRecord/queryAnswer', params, {
        ...opts,
        method: 'post'
    });


// 删除附件
export const DeleteAttachment = (params, opts) =>
    request('/api-resource/question/deleteAttachment', params, opts);   // params {id: ''}

//===================================


export const materialHandleNodeClick = (params, opts) => request("/api-resource/cjdd-resources/resourses/get/material/attachment/lists", params, { ...opts, method: "post" });
export const materialSearch = (params, opts) => request("/api-resource/cjdd-resources/resourses/get/material/attachment/lists", params, { ...opts, method: "post" });
export const deleteMaterial = (params, opts) => request("/api-study/study/getResourceCourseProgress", params, { ...opts, method: "post" });

// 根据资源id获取详细信息
export const previewSource = (id, params, opts) => request("/api-resource/cjdd-resources/resourses/get/material/attachment/one?id="+id, params, opts);

// 意见反馈保存
export const saveFeedBack = (params, opts) => request("/api-msg/msg/feedback2/save", params, {...opts, method: "post"});

//==============================书证融通改版=======================================
//获取导航栏目
export const querySetPliot = (params, opts) => request("/api-course/course/pliot/querySetPliot", params, {...opts, method: "post"});
//获取导航栏目
export const queryPilotSet = (params, opts) => request("/api-course/course/pliot/queryPilotSet", params, {...opts, method: "get"});
//设置导航栏
export const setPliot = (params, opts) => request("/api-course/course/pliot/setPliot", params, {...opts, method: "post"});
//根据课程id查询课程资源分类
export const getSourceClassify = (params, opts) => request("/api-course/categoryResource/findResCategoryByCourseId", params, opts);
//添加资源分类
export const addSourceClassify = (params, opts) => request("/api-course/categoryResource/editResCategoryByCourseId", params, {...opts, method: "post"});
//删除资源分类
export const deleteSourceClassify = (id, params, opts) => request(`/api-course/categoryResource/deleteResCategoryByCourseId/${id}`, params, { ...opts, method: "delete" });
//资源分类排序
export const sourceClassifySort = (params, opts) => request("/api-course/categoryResource/moveResCategoryByCourseId", params, {...opts, method: "put"});
//获取资源列表
export const getSourceList = (params, opts) => request("/api-course/categoryResource/findPage/resource", params, {...opts, method: "post"});
//学生端获取课程目录
export const stuGetCatalogue = (params, opts) => request("/api-course/catalog/queryCourseByIdAndType", params, {...opts, method: "post"});
// 获取课程目录 预览视角
export const stuGetCataloguePreview = (params, opts) => request("/api-course/catalog/queryCourseOnIsPreView", params, {...opts, method: "post"});
// 获取平台地址
export const getPlatformPath = (id, params, opts) => request(`/api-course/course/platformPathCourse/query/${id}`, params, opts);
// 保存平台地址
export const savePlatformPath = (params, opts) => request("/api-course/course/platformPathCourse/eidt", params, {...opts, method: "post"});
export const savePlatformPathV2 = (params, opts) => request("/api-course/course/platformPathCourse/eidtPlatformPathCourseV2", params, {...opts, method: "post"});




// api-studylog/noAuth/common/save
/*
*   wjl
* */
//大数据埋点
export const postBigDataPoint = (params) => request("/api-studylog/noAuth/common/save", params, { method: "post"});
//根据课程id查询课程库试题
export const postGetQuestionByCourseId = (params) => request("/api-course/categoryResource/findQuestionByCourseId", params, { method: "post"});
//根据课程id查询课程库试题
export const postGetPaperByCourseId = (params) => request("/api-course/categoryResource/findPaperByCourseId", params, { method: "post"});


/**
 * 课程 - 目录 - 创建实操题 & 删除试题和试卷
*/
// 添加试题
export const createQuestiontData_new = (params, opts) => request('/api-course/catalog/add/questionToResource', params, { ...opts, method: 'post' });
// 添加试题
export const deleteFromCatalog = (params, opts) => request('/api-course/categoryResource/deleteFromCatalog', params, { ...opts, method: 'post' });


//获取rpa下载链接
export const queryRecord = (params, opts) => request('/api-studylog/questionRecord/queryRecord', params, { ...opts, method: 'post' });

//共享资源列表
export const shareResourceList = (params, opts) => request('/api-course/catalog/query/shareResource', params, { ...opts, method: 'post' });
//共享资源列表 -- 预览
export const shareResourceListPreview = (params, opts) => request('/api-course/catalog/query/shareResource/onPreView', params, { ...opts, method: 'post' });

// 课程库课程信息查询
export const courseUpdateV2 = (params, opts) => request('/api-course/course/updateV2', params, { ...opts, method: 'put' });

// 课程目录自动设置编号的标识
export const courseAutomatic = (params, opts) => request('/api-course/courseSet/eidt', params, { ...opts, method: 'post' });

// 获取课程是否自动编号
export const getCourseAutomatic = (params, opts) => request('/api-course/courseSet/queryCourseSet', params, { ...opts, method: 'post' });
  //  查授权的接口
  export const coursePermissions = (courseId,params, opts) => request(`/api-course/authCourse/checkCourseAuth/${courseId}`, params, { ...opts, method: "get", });
//   统计当前目录各个种类的数量
export const statisticalTypeNumber= (params, opts) => request('/api-course/course/queryResourceDetail', params, { ...opts, method: 'post' });

//  修改课程编辑模式 ， 1现有的编辑模式， 2是IT那边的新模式，兼容到所有课程中
export const courseSetEditMode= (params, opts) => request('/api-course/courseSet/editMode', params, {  method: 'post' });

// RPA数据重置
export const resetData = (params, opts) => request('/api-course/templateCode/reset/saveOne', params, {  method: 'post' });
// RPA数据重置查询次数
export const getResetData = (params, opts) => request('/api-course/templateCode/reset/findOne', params, {  method: 'post' });

// 获取 java 结果
export const getJavaResult = (id) => request('/api-java-compile/java/compile/result/' + id);
// python 运行
export const pythonRunCoder = (params) => request('/python-compile/run_code', params,{ method: 'post' , contentType:'application/x-www-form-urlencoded', qsParams: true });

// c || c++ 运行
export const cppRunCoder = (params) => request('/api-cpp-compile/cpp/run', params,{ method: 'post' });

// java 运行
export const javaRunCoder = (params) => request('/api-java-compile/java/compile/submit', params,{ method: 'post' });
// c# 运行
export const csRunCoder = (params) => request('/api-dotnet-compile/api/Code', params, { method: 'post' });

/* 班级考核标准 */
// 查询考核标准
export const queryAssessStandard = (courseId, classId, params, opts) => request(`/api-course/course/cuAssessmentCriteria/query/${courseId}/${classId}`, params, { ...opts, method: "get" });
// 保存考核标准
export const saveAssessStandard = (params, opts) => request("/api-course/course/cuAssessmentCriteria/save-or-update", params, { ...opts, method: "post" });



// WEBPACK FOOTER //
// ./src/api/courseApi.js